import {User} from "../models/user";
import {StorageService} from "ngx-webstorage-service";
import {catchError, map} from "rxjs/operators";
import {UtilitiesService} from "../helpers/utilities.service";
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Inject, Injectable, InjectionToken} from '@angular/core';
import {BehaviorSubject, Observable, of, throwError} from "rxjs";

const STORAGE_KEY = 'current-user';
export const USER_SERVICE_STORAGE =
    new InjectionToken<StorageService>('USER_SERVICE_STORAGE');

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {

    headers = new HttpHeaders({
        'Content-Type': 'application/json'
    });

    public loggedInUser$: Observable<User>;
    private loggedInUserSubject: BehaviorSubject<User>;

    constructor(private http: HttpClient,
                private utils: UtilitiesService,
                @Inject(USER_SERVICE_STORAGE) private storage: StorageService) {
        this.loggedInUserSubject = new BehaviorSubject<User>(this.getUserFromStorage());
        this.loggedInUser$ = this.loggedInUserSubject.asObservable();
    }

    public setLoggedUser(loggedUser: User): void {
        this.storage.set(STORAGE_KEY, loggedUser);
        this.loggedInUserSubject.next(this.getUserFromStorage());
    }

    public async validateSession(): Promise<any> {
        let user: User = this.getUserFromStorage();
        user.role = this.getUserFromStorage()['authorities'][0]["authority"];
        return await this.postRequest(user, "validate-session");
    }

    public async register(user: User): Promise<any> {
        return await this.postRequest(user, "register");
    }

    public async login(user: User): Promise<any> {
        return await this.postRequest(user, "login");
    }

    public async logout(): Promise<any> {
        this.setLoggedUser(null);
        
        return await this.http.get<any>(this.utils.getAuthApi("logout")).toPromise();
    }

    public async sendResetPasswordMail(user: User): Promise<any> {
        return await this.postRequest(user, "reset-password");
    }

    private async postRequest(user: User, url: string): Promise<any> {
        return await this.http.post(this.utils.getAuthApi(url), JSON.stringify(user), {headers: this.headers}).toPromise();
    }

    public getUserFromStorage(): User {
        const currentUser: User = this.storage.get(STORAGE_KEY) || null;
        return currentUser;
    }
}
